import { createStore } from "redux";
import Reducers from "./Reducers";

const store = createStore(Reducers);

export default store;